import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppSettingsDto } from "../../services/api.services";
import { SettingsDrivenPipeOverride } from "./settings-driven-pipe-override";
import { LocalisationService } from "../../services/localisation.service";
import moment from 'moment';
import { TimezoneSettings } from './date-with-timezone.pipe';

@Pipe({
  name: 'date',
  pure: false,
  standalone: false
})
export class SettingsDrivenDatePipe extends SettingsDrivenPipeOverride<DatePipe> implements PipeTransform {
  protected getPipe() {
    return new DatePipe(this.pipeLocale);
  }

  protected onTransform(pipe: DatePipe, settings: AppSettingsDto, value: any, format?: string, timezone?: string, locale?: string)
  protected onTransform(pipe: DatePipe, settings: AppSettingsDto, value: any, format?: string, timezone?: TimezoneSettings, locale?: string)
  protected onTransform(pipe: DatePipe, settings: AppSettingsDto, value: any, format?: string, timezone?: any, locale?: string) {
    let _timezoneSettings: TimezoneSettings = null;

    if (timezone && typeof timezone == "string")
      _timezoneSettings = { offset: timezone };

    if (timezone && typeof timezone == "object")
      _timezoneSettings = timezone;


    let formatString = this.localisationService.CUSTOM_DATE_FORMATS[format] || format;
    const locale_ = locale ?? settings.locale ?? this.pipeLocale;
    const timezone_ = _timezoneSettings?.offset ?? moment.tz(_timezoneSettings?.dstDate ?? value, _timezoneSettings?.iana ?? settings.timeZoneIana).format('Z');
    if (locale_.toLowerCase() === 'ja-JP'.toLowerCase()) {
      formatString = this.localisationService.mapToJapaneseFormat(formatString);
    }

    return pipe.transform(value, formatString, timezone_, locale_);
  }
}
